import Button from '@mui/material/Button';
import { Row } from 'further-ui/components/Layout';

type Props = {
  onBack: () => void;
  onSave: () => void;
};

const ActionBar: React.FC<Props> = ({ onBack, onSave }) => {
  return (
    <Row fullWidth justify="space-between">
      <Button onClick={onBack} size="large" variant="outlined">
        Cancel
      </Button>
      <Button onClick={onSave} size="large" variant="contained">
        Save
      </Button>
    </Row>
  );
};

export default ActionBar;
